import common from "../../common";
import QuestionValue from "../../maths/QuestionValue";
import QuestionViewVerbal from "./QuestionViewVerbal";
import converter from "../../../libs/number-to-words";

export default class QuestionViewVerbalValue extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const templates = P3.assets.json("templates").templates;
        const split = this._question.template.split("/");

        const words = data.words;

        if (!templates) return "ERROR: NO TEMPLATE FOUND";

        let text = P3.utils.selectRandom(P3.utils.objectToArray(templates[split[0]][split[1]])).text;

        let match = text.match(/\[VALUE([0-9])?]/g);

        if (match) {
            text = text.replace(match, converter.toWords(this._question.answer.value));
        }

        const enemies = this.generateWords(text, words.enemies, /\[ENEMY([0-9])?]/g);
        for (const i in enemies) {
            if (enemies.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
            }
        }

        let char = this.generateWords(text, words.character_class, /\[CHARACTER_CLASS([0-9])?]/g);
        for (const i in char) {
            if (char.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), char[i]);
            }
        }

        let char_2 = this.generateWords(text, words.character_class_2, /\[CHARACTER_CLASS_TWO([0-9])?]/g);
        for (const i in char_2) {
            if (char_2.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), char_2[i]);
            }
        }

        const activities = this.generateWords(text, words.character_activities, /\[CHARACTER_ACTIVITIES([0-9])?]/g);
        if (activities) {
            for (const i in activities) {
                if (activities.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), activities[i]);
                }
            }
        }

        return text;
    }

    isCorrect() {
        return this._inputValue.value === this._question.answer.value;
    }

    filterTemplate(x) {
        return true;
    }
}